import React from 'react';
import styled from 'styled-components';

import { COLORS } from '../Color';

const Pagination = ({
  currentPage,
  totalPages,
  onPageChange,
}: {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}) => {
  const renderPageNumbers = () => {
    const pageNumbers = [];
    const maxVisiblePages = 5; // 표시할 최대 페이지 수 (중간에 '...' 포함)
    let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    if (startPage > totalPages - maxVisiblePages + 1) {
      startPage = Math.max(1, totalPages - maxVisiblePages + 1);
      endPage = totalPages;
    }

    if (totalPages > 5 && currentPage > 3) {
      // 첫 번째 페이지는 항상 표시
      if (startPage > 1) {
        pageNumbers.push(
          <div key={1} onClick={() => onPageChange(1)}>
            <PageNumberText isActive={1 === currentPage}>{1}</PageNumberText>
          </div>,
        );
      }

      // '...' 표시 (왼쪽)
      if (startPage > 1 && currentPage > 3) {
        pageNumbers.push(
          <div key="dots-left">
            <PageNumberText isActive={false}>...</PageNumberText>
          </div>,
        );
      }
    }
    // 페이지 번호 표시 (중간 페이지들)
    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <div key={i} onClick={() => onPageChange(i)}>
          <PageNumberText isActive={i === currentPage}>{i}</PageNumberText>
        </div>,
      );
    }

    if (totalPages > 5) {
      // '...' 표시 (오른쪽)
      if (endPage - 1 < totalPages && currentPage < totalPages - 2) {
        pageNumbers.push(
          <div key="dots-right">
            <PageNumberText isActive={false}>...</PageNumberText>
          </div>,
        );
      }

      // 마지막 페이지는 항상 표시
      if (endPage - 1 < totalPages && currentPage < totalPages - 2) {
        pageNumbers.push(
          <div key={totalPages} onClick={() => onPageChange(totalPages)}>
            <PageNumberText isActive={totalPages === currentPage}>
              {totalPages}
            </PageNumberText>
          </div>,
        );
      }
    }
    return pageNumbers;
  };
  return (
    <PaginationContainer>
      <ArrowBox isEnabled={currentPage !== 1}>
        <ArrowButton
          onClick={
            currentPage !== 1 ? () => onPageChange(currentPage - 1) : () => {}
          }
        >
          {currentPage !== 1 ? (
            <img src="/assets/images/arrow/pageLeftOn.svg" alt="" />
          ) : (
            <img src="/assets/images/arrow/pageLeftOff.svg" alt="" />
          )}
        </ArrowButton>
        <div>이전</div>
      </ArrowBox>
      <PageNumbersContainer>{renderPageNumbers()}</PageNumbersContainer>
      <ArrowBox isEnabled={currentPage !== totalPages}>
        <div>다음</div>
        <ArrowButton
          onClick={
            currentPage !== totalPages
              ? () => onPageChange(currentPage + 1)
              : () => {}
          }
        >
          {currentPage !== totalPages ? (
            <img src="/assets/images/arrow/pageRightOn.svg" alt="" />
          ) : (
            <img
              style={{ transform: 'rotate(180deg)' }}
              src="/assets/images/arrow/pageLeftOff.svg"
              alt=""
            />
          )}
        </ArrowButton>
      </ArrowBox>
    </PaginationContainer>
  );
};

export default Pagination;

interface ArrowBoxProps {
  isEnabled: boolean;
}

const ArrowBox = styled.div<ArrowBoxProps>`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  cursor: ${({ isEnabled }) =>
    isEnabled ? 'pointer' : 'default'}; /* props 접근 방식 수정 */
  color: ${({ isEnabled }) =>
    isEnabled ? '#616161' : 'rgba(55, 56, 60, 0.16)'};
`;

const PaginationContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-top: 40px;
  margin-bottom: 40px;
`;

const PageNumbersContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const PageNumberText = styled.span<{ isActive: boolean }>`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  font-family: 'Spoqa Han Sans Neo';
  width: 40px;
  height: 40px;
  font-size: 16px;
  font-weight: 700;
  line-height: 26.4px;
  color: ${({ isActive }) => (isActive ? '#fff' : COLORS.tertiary)};
  background-color: ${({ isActive }) => (isActive ? '#008AFF' : 'none')};
  border-radius: 4px;
  cursor: pointer;
`;

const ArrowButton = styled.div`
  cursor: pointer;
  // img {
  //   width: 14px;
  //   height: 8px;
  // }
`;
